import { useMemo, useState, useRef, useEffect } from "react"
import { TextField, InputAdornment, IconButton } from "@mui/material"
import { Search, Close } from "@mui/icons-material"
import PropTypes from "prop-types"
import { debounce } from "lodash"

export default function MetricsSearch({ shouldFocus, metricsSearchValue, setMetricsSearchValue, analytics }) {
  const [localSearchValue, setLocalSearchValue] = useState(metricsSearchValue)
  const inputRef = useRef(null)

  const debouncedSetMetricsSearchValue = useMemo(
    () => debounce((search) => {
      setMetricsSearchValue(search)
      if (search.trim() !== "") {
        analytics?.trackSearchPerformed?.(search.trim())
      }
    }, 200),
    [setMetricsSearchValue, analytics],
  )

  function handleChange(event) {
    setLocalSearchValue(event.target.value)
    debouncedSetMetricsSearchValue(event.target.value)
  }

  function handleClear() {
    setLocalSearchValue("")
    setMetricsSearchValue("")
  }

  useEffect(() => {
    if (shouldFocus) {
      inputRef.current?.focus()
    }
  }, [shouldFocus])

  return <div className="metrics-search-wrapper">
    <TextField
      variant="outlined"
      inputRef={inputRef}
      size="small"
      fullWidth
      placeholder="Search for metrics"
      value={localSearchValue}
      onChange={handleChange}
      slotProps={{
        input: {
          classes: {
            root: "metrics-search-input",
          },
          startAdornment: (
            <InputAdornment position="start">
              <Search />
            </InputAdornment>
          ),
          endAdornment: metricsSearchValue !== "" && (
            <InputAdornment position="end">
              <IconButton onClick={handleClear}>
                <Close />
              </IconButton>
            </InputAdornment>
            ),
         },
      }}
    />
  </div>
}

MetricsSearch.propTypes = {
  metricsSearchValue: PropTypes.string.isRequired,
  setMetricsSearchValue: PropTypes.func.isRequired,
  shouldFocus: PropTypes.bool,
  analytics: PropTypes.object,
}
